import EventDetailStandings from '@/screens/EventDetailStandings';

export default function PrivateTabsOrganizationScheduleScheduleAEventIdStandingsRoute() {
  return <EventDetailStandings />;
}
